<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            :color="color"
            title="Subscriptions"
            text="A table of Subscriptions"
          >
            <v-spacer/>

            <v-dialog
              v-model="dialog"
              :persistent="!updating"
              max-width="768px">
              <template v-slot:activator="{ on }">
                <v-layout>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-btn
                      :color="color"
                      dark
                      class="mb-2"
                      v-on="on">
                      New Subscription
                    </v-btn>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md6>
                    <v-text-field
                      v-model="search"
                      :loading="loading"
                      append-icon="search"
                      label="Search"
                      hide-details/>
                  </v-flex>
                </v-layout>
              </template>
              <v-card>
                <v-card-text>
                  <v-container grid-list-md >
                    <h3
                      v-if="updating&&!editedSubscription.has_stripe_subscription"
                      style="color:lightcoral"> Error: <br> <em>Creating subscription failed! Check logs for details.</em></h3>
                    <h4>Subscription Information</h4>

                    <v-layout wrap>
                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-select
                          :disabled="updating"
                          :rules="[rules.required]"
                          v-model="editedSubscription.client_id"
                          :items="sortedClients"
                          item-text="name"
                          item-value="id"
                          label="Client"
                          dense
                        />
                      </v-flex>

                      <v-flex
                        xs12
                        sm6
                        md6>
                        <v-select
                          :disabled="updating"
                          :rules="[rules.required]"
                          v-model="editedSubscription.payment_type"
                          :items="[{'name':'One Time', 'value':'one-time'},{'name':'Recurring', 'value': 'recurring'}]"
                          item-text="name"
                          item-value="value"
                          label="Type"
                          dense
                        />
                      </v-flex>
                      <p
                        v-if="editedSubscription.payment_type == ''"
                        style="color:red;text-align:right">You can only add items after you select the 'Type'</p>

                      <table style="font-size: 10px;width:100%; table-layout: fixed; border-collapse: collapse">

                        <template v-for="item in editedSubscription.items">
                          <tr @click="editItem(item)">
                            <td
                              v-if="item.service"
                              style="font-size: 12px;width:60%;text-align: left">
                              {{ item.service.name }}
                            </td>
                            <td style="width:30%; white-space: pre-wrap; text-align: right;">
                              Quantity: {{ item.quantity }}
                            </td>
                            <td
                              v-if="item.service"
                              rowspan="2"
                              style="width:10%;white-space: pre-wrap; text-align: right;">
                              ${{ (item.service.price- (item.discount_type == 'amount'?item.discount: item.discount/100*item.service.price)) * item.quantity }}
                            </td>
                          </tr>
                          <tr
                            style="border-bottom: 1px solid gray"
                            @click="editItem(item)">
                            <td
                              v-if="item.service"
                              style="text-align: left;">
                              {{ item.service.description }}
                            </td>
                            <td
                              v-if="item.service"
                              style="text-align: right;">
                              Unit Price: <br >
                              ${{ item.service.price }} <span v-if="item.discount !=0"> - ${{ item.discount_type == 'amount'?item.discount: item.discount/100*item.service.price }}  = ${{ item.service.price - (item.discount_type == 'amount'?item.discount: item.discount/100*item.service.price) }} </span>
                            </td>
                          </tr>
                        </template>
                        <tr>
                          <td
                            colspan="3"
                            style="text-align: right;white-space: pre-wrap;">
                            Total: ${{ editedSubscription.total_price || 0 }}
                          </td>

                        </tr>
                        <tr>
                          <td
                            colspan="3"
                            style="text-align: right;white-space: pre-wrap;">
                            Commission: ${{ editedSubscription.total_price? editedSubscription.total_price * editedSubscription.commission_rate / 100: 0 }}
                          </td>
                        </tr>
                      </table>

                      <v-dialog
                        v-if="!updating && editedSubscription.payment_type !=''"
                        v-model="itemDialog"
                        :persistent="!updating"
                        z-index="100000"
                        max-width="600px">
                        <template v-slot:activator="{ on }">

                          <div style="width: 100%;">
                            <v-btn
                              :color="color"
                              style="float:right"
                              dark
                              class="mb-2"
                              v-on="on">
                              Add an item
                            </v-btn>
                          </div>
                        </template>
                        <v-card>
                          <v-card-text>
                            <v-container grid-list-md >
                              <h4>Item</h4>

                              <v-layout wrap>
                                <v-flex
                                  xs12
                                  sm6
                                  md6>
                                  <v-select
                                    :disabled="updating||updatingItem"
                                    :rules="[rules.required]"
                                    v-model="editedItem.service_id"
                                    :items="editedSubscription.payment_type == 'recurring'?sortedRecurringServices:sortedOneTimeServices"
                                    item-text="name"
                                    item-value="id"
                                    label="Service"
                                    dense
                                  />
                                </v-flex>

                                <v-flex
                                  xs12
                                  sm6
                                  md6>
                                  <v-text-field
                                    :rules="[rules.required]"
                                    v-model="price"
                                    disabled
                                    disabled
                                    label="Original Unit Price($)" />
                                </v-flex>

                                <v-flex
                                  xs12
                                  sm6
                                  md6>
                                  <v-select
                                    :disabled="updating"
                                    :rules="[rules.required]"
                                    v-model="editedItem.discount_type"
                                    :items="['percent', 'amount']"
                                    label="Discount Type"
                                    dense
                                  />
                                </v-flex>

                                <v-flex
                                  xs12
                                  sm6
                                  md6>
                                  <v-text-field
                                    :disabled="updating"
                                    :rules="[rules.required]"
                                    v-model="editedItem.discount"
                                    :label="'Discount per Unit('+ (editedItem.discount_type == 'amount'?'$':'%') +')'"
                                    type="number" />
                                </v-flex>

                                <v-flex
                                  xs12
                                  sm12
                                  md12>
                                  Price:&nbsp;&nbsp;&nbsp;
                                  ${{ unitPrice }} &nbsp;&nbsp;&nbsp;X&nbsp;&nbsp;&nbsp;
                                  <v-text-field
                                    :disabled="updating"
                                    :rules="[rules.required]"
                                    v-model="editedItem.quantity"
                                    style="width: 80px; display: inline-flex"
                                    type="number"
                                    label="Quantity" />
                                  &nbsp;&nbsp;&nbsp;= &nbsp;&nbsp;&nbsp;${{ total }}
                                </v-flex>

                              </v-layout>
                            </v-container>

                            <p style="color:red">{{ itemErrorMessage }}</p>
                          </v-card-text>

                          <v-card-actions v-if="!updating">
                            <v-spacer />
                            <v-spacer/>
                            <v-btn
                              color="blue darken-1"
                              flat
                              @click="itemClose">Cancel</v-btn>
                            <v-btn
                              color="blue darken-1"
                              flat
                              @click="itemSave">Save</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>

                      <div
                        v-if="editedSubscription.payment_type=='recurring'"
                        style="width:100%">
                        <v-layout>
                          <v-flex
                            xs12
                            sm6
                            md6
                          >
                            <v-select
                              :disabled="updating"
                              v-model="billingCycle"
                              :items="billingCycles"
                              label="Billing Cycle"
                              class="cycle-item"
                              attach=".cycles"
                              menu-props="auto"
                              dense
                            >
                              <template slot="selection">
                                {{ this.billingCycleWord }}
                              </template>
                            </v-select>
                          </v-flex>
                          <v-flex
                            xs12
                            sm6
                            md6
                          >
                            <v-select
                              v-model="editedSubscription.start_date"
                              :items="this.firstBillDates"
                              item-text="name"
                              item-value="value"
                              label="First Bill Date"
                              dense
                            />
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex
                            xs12
                            sm12
                            md12>
                            <div
                              class="cycles"
                              style="display: block"/>
                          </v-flex>
                        </v-layout>
                        <v-layout>
                          <v-flex
                            xs12
                            sm12
                            md12>
                            <v-radio-group
                              v-model="hasEndDate"
                              column
                            >
                              <v-radio
                                label="No end date"
                                value="false"
                              />
                              <v-radio
                                value="true"
                              >
                                <template v-slot:label>
                                  Fixed number of occurrences:
                                  &nbsp;&nbsp;
                                  <v-text-field
                                    v-model="occurrence"
                                    style="width: 70px;padding-left:20px"
                                    type="number"
                                    min="1"
                                  />
                                  <span v-if="editedSubscription.end_date">
                                    &nbsp;&nbsp;
                                    End Date: {{ editedSubscription.end_date }}
                                  </span>
                                </template>
                              </v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </div>

                      <h5
                        v-if="editedSubscription.payment_type=='one-time'"
                        style="color:lightgreen">This is a one time charge!</h5>
                    </v-layout>

                    <div v-if="editedSubscription.client_id">
                      <h4>Affiliate Information</h4>
                      <v-layout wrap>

                        <v-flex
                          xs12
                          sm6
                          md6>
                          <v-select
                            v-model="client.affiliate_id"
                            :items="affiliateList"
                            style="border-style:none"
                            disabled
                            item-text="user.name"
                            item-value="id"
                          />
                        </v-flex>

                        <v-flex
                          xs12
                          sm6
                          md6>
                          <v-text-field
                            :disabled="updating"
                            :rules="[rules.required]"
                            v-model="editedSubscription.commission_rate"
                            type="number"
                            label="Commission(%)" />
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-container>
                  <p style="color:red">{{ subscriptionErrorMessage }}</p>
                </v-card-text>

                <v-card-actions v-if="!updating">
                  <v-spacer />
                  <v-spacer/>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="close">Cancel</v-btn>
                  <v-btn
                    color="blue darken-1"
                    flat
                    @click="save">Save</v-btn>
                </v-card-actions>
                <v-card-actions v-else>
                  <v-spacer />
                  <v-spacer/>
                  <span
                    v-if="this.editedSubscription.end_date"
                    style="color:red">
                    Subscription Cancelled
                  </span>
                  <v-btn
                    v-else
                    color="red darken-1"
                    @click="cancelSubscription">Cancel Subscription</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :headers="headers"
              :items="SubscriptionList"
              :disable-initial-sort="true"
              :rows-per-page-items ="rowsAmount"
              :search="search"
              class="elevation-1"
            >

              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props">
                <tr @click="editSubscription(props.item)">
                  <td>
                    <v-select
                      v-model="props.item.client_id"
                      :items="clientList"
                      disabled
                      item-text="name"
                      item-value="id"
                      label=""
                      dense
                    />
                  </td>
                  <td>
                    {{ props.item.payment_type }}
                  </td>

                  <td>
                    {{ props.item.start_date }}
                  </td>
                  <td>
                    {{ props.item.total_price?'$'+props.item.total_price:'N/A' }}
                  </td>
                  <td>
                    {{ new Date(props.item.created_at).toLocaleString() }}
                    <v-icon
                      v-if="!props.item.has_stripe_subscription"
                      small
                      color="red"
                      @click="showWarningMessage('Subscription Creation Failed, Maybe payment for client is not verified.')">warning</v-icon>
                  </td>
                  <td>
                    <v-icon
                      v-if="props.item.ended_date != null"
                      small
                      color="red"
                      @click="showWarningMessage('Subscription Cancelled.')">error</v-icon>
                    <span v-if="!props.item.ended_date">{{ props.item.ended_date }}</span>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close</v-btn>
            </v-snackbar>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import { mapState } from 'vuex'

  export default {
  data: () => ({
    snack: false,
    itemErrorMessage: 'Setting quantity to 0 to remove it',
    subscriptionErrorMessage: '',
    snackColor: '',
    snackText: '',
    rules: {
      required: value => !!value || 'Required.',
      max25chars: v => v.length <= 25 || 'Input too long!',
      // counter: value => value.length <= 20 || 'Max 20 characters',
      email: value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    },
    pagination: {},
    SubscriptionList: [

    ],
    affiliateList: [],
    clientList: [],
    serviceList: [],
    client: {},
    affiliate: {},
    service: {},
    price: 0,
    updating: false,
    updatingItem: false,
    loading: true,

    startCalendar: false,
    endCalendar: false,

    backdated: false,
    firstDay: '',
    lastDay: '',
    billingCycle: 0,
    firstBillDates: [],
    billingCycleWord: '',
    hasEndDate: 'false',
    occurrence: 1,
    checkboxAdmin: true,
    checkboxActive: true,
    rowsAmount: [10, 20, 50, { 'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1 }],
    dialog: false,
    itemDialog: false,
    search: '',
    headers: [
      {
        text: 'Client',
        align: 'left',
        value: 'client_id'
      },
      {
        text: 'Type',
        align: 'left',
        value: 'payment_type'
      },
      {
        text: 'Start',
        align: 'left',
        value: 'start_date'
      },
      {
        text: 'Total',
        align: 'left',
        value: 'total_price'
      },
      {
        text: 'Created At',
        align: 'left',
        value: 'created_at'
      },
        {
            text: 'Cancelled',
            align: 'left',
            value: 'ended_date'
        }
    ],
    editedIndex: -1,
    editedSubscription: {
      id: '',
      commission_rate: 10,
      payment_type: '',
      start_date: '',
      end_date: '',
      client_id: '',
      created_at: '',
      has_stripe_subscription: false,
      items: []
    },
    defaultEditedSubscription: {
      id: '',
      commission_rate: 10,
      payment_type: '',
      start_date: '',
      end_date: '',
      client_id: '',
      created_at: '',
      has_stripe_subscription: false,
      items: []
    },
    editedItem: {
      quantity: 1,
      service_id: '',
      discount: 0,
      discount_type: 'amount'
    },
    defaultSubscription: {
      id: '',
      commission_rate: 10,
      payment_type: '',
      start_date: '',
      end_date: '',
      created_at: '',
      has_stripe_subscription: false,
      items: []
    },
    defaultItem: {
      quantity: 1,
      service_id: '',
      discount: 0,
      discount_type: 'amount'
    },
    billingCycles: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31]
  }),

  computed: {
    ...mapState('app', ['color']),
    formTitle () {
      return this.editedIndex === -1 ? 'New Subscription' : 'Edit Subscription'
    },
    sortedClients () {
      return this.clientList
              .filter(c => c.has_payment && c.active)
              .sort(function (a, b) {
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
              })
    },
    sortedServices () {
      return this.serviceList
              .filter(c => c.active)
              .sort(function (a, b) {
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
              })
    },
    sortedRecurringServices () {
      return this.serviceList
              .filter(c => c.active && c.type == 'recurring')
              .sort(function (a, b) {
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
              })
    },
    sortedOneTimeServices () {
      return this.serviceList
              .filter(c => c.active && c.type == 'one-time')
              .sort(function (a, b) {
                return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
              })
    },
    unitPrice () {
      if (this.editedItem.discount_type == 'amount') {
        return this.price - parseFloat(this.editedItem.discount)
      } else {
        return this.price * (100 - parseFloat(this.editedItem.discount)) / 100
      }
    },
    total () {
      return this.unitPrice * parseInt(this.editedItem.quantity)
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    'editedItem.service_id': function (newValue, oldValue) {
      for (var i = 0; i < this.serviceList.length; i++) {
        if (this.serviceList[i].id == newValue) {
          this.service = this.serviceList[i]
          this.price = parseFloat(this.serviceList[i].price)
          break
        }
      }
    },
    occurrence: function (newValue, oldValue) {
      if (this.editedSubscription.start_date) {
       this.updateEndDate()
      }
    },
    'editedSubscription.start_date': function (newValue, oldValue) {
      this.updateEndDate()
    },
    hasEndDate: function (newValue, oldValue) {
      this.updateEndDate()
    },
        'editedSubscription.client_id': function (newValue, oldValue) {
      // if (this.editedItem.id === '') {
        let self = this
        for (var i = 0; i < this.clientList.length; i++) {
          if (this.clientList[i].id == newValue) {
            this.client = this.clientList[i]
            this.editedSubscription.commission_rate = this.client.commission_rate
            for (var j = 0; j < self.affiliateList.length; j++) {
              if (self.affiliateList[j].id == this.client.id) {
                self.affiliate = self.affiliateList[j]
                break
              }
            }

            break
          }
        }
      // }
    },
    billingCycle: function (newValue, oldValue) {
      // var d1 = Date.parse(newValue);
      var d2 = new Date()
      d2.setDate(Math.min(newValue, d2.getDaysInMonth()))
      d2.setHours(23)
      d2.setMinutes(59)
      d2.setSeconds(59)
      this.backdated = d2 < (new Date())
      // console.log('backdated: ' + this.backdated)
      // console.log(newValue);
      // console.log('current date:' + (new Date()));
      // console.log('d2:' + (new Date(d2)));
      this.billingCycleWord = 'Due on the ' + this.ordinal_suffix_of(d2.getDate()) + ' each month!'

      var d = new Date()
      d.setUTCDate(Math.min(newValue, d2.getDaysInMonth()))
      this.firstBillDates = []
      if (this.backdated) {
        this.firstBillDates.push({name: 'Today', value: d.formatDate()})
      } else {
        d.addMonths(-1)
        this.firstBillDates.push({name: 'Today', value: d.formatDate()})
      }
      for (var i = 0; i < 17; i++) {
        var tempDateCopy = new Date(d.getTime())
        var newDate = tempDateCopy.addMonths(i + 1).setUTCDate(Math.min(newValue, tempDateCopy.getDaysInMonth()))
        newDate = tempDateCopy.formatDate()
        var obj = {}
        obj = {name: newDate, value: newDate}
        this.firstBillDates.push(obj)
      }
      this.editedSubscription.start_date = ''
    }

  },
  // called when page is created before dom
  created () {
    this.index()
    this.billingCycle = 1
    // this.$store.dispatch('autoRefreshToken')
    // .then(response => console.log(response))
    // .catch(error => console.log(error))
    var date = new Date(), y = date.getFullYear(), m = date.getUTCMonth()
    this.firstDay = new Date(y, m, 1).toISOString().slice(0, 10)
    this.lastDay = new Date(y, m + 1, 0).toISOString().slice(0, 10)
    Date.isLeapYear = function (year) {
      return (((year % 4 === 0) && (year % 100 !== 0)) || (year % 400 === 0))
    }

    Date.getDaysInMonth = function (year, month) {
      return [31, (Date.isLeapYear(year) ? 29 : 28), 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month]
    }

    Date.prototype.isLeapYear = function () {
      return Date.isLeapYear(this.getFullYear())
    }

    Date.prototype.getDaysInMonth = function () {
      return Date.getDaysInMonth(this.getFullYear(), this.getUTCMonth())
    }

    Date.prototype.addMonths = function (value) {
      var n = this.getUTCDate()
      this.setUTCDate(1)
      this.setUTCMonth(this.getUTCMonth() + value)
      this.setUTCDate(Math.min(n, this.getDaysInMonth()))
      return this
    }
    Date.prototype.formatDate = function () {
          var month = '' + (this.getUTCMonth() + 1),
          day = '' + this.getUTCDate(),
          year = this.getFullYear()

      if (month.length < 2) { month = '0' + month }
      if (day.length < 2) { day = '0' + day }

      return [year, month, day].join('-')
    }
  },

  methods: {
    updateEndDate () {
      if (this.hasEndDate == 'true') {
        var d = new Date(this.editedSubscription.start_date)
        var monNumber = parseInt(this.occurrence)
        this.editedSubscription.end_date = d.addMonths(monNumber).formatDate()
      } else {
        this.editedSubscription.end_date = ''
      }
  },
    ordinal_suffix_of (i) {
    var j = i % 10,
        k = i % 100
    if (j == 1 && k != 11) {
      return i + 'st'
    }
    if (j == 2 && k != 12) {
      return i + 'nd'
    }
    if (j == 3 && k != 13) {
      return i + 'rd'
    }
    return i + 'th'
  },
  index () {
      this.loading = true
      let self = this
      axios.get('/api/admin/subscriptions')
              .then(response => {
                self.SubscriptionList = response.data
                self.loading = false
                self.getServices()
                self.getClients()
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },
    getAffiliates () {
      let self = this
      axios.get('/api/admin/affiliates')
              .then(response => {
                self.affiliateList = response.data
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },
    getServices () {
      let self = this
      axios.get('/api/services')
              .then(response => {
                self.serviceList = response.data
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },
    getClients () {
      let self = this
      axios.get('/api/admin/clients')
              .then(response => {
                self.clientList = response.data
                self.getAffiliates()
              })
              .catch(err => {
                if (err.response.status == '403') {
                  this.showError('Unauthorized')
                } else {
                  this.showError(err.response.data.errors)
                }
                self.loading = false
                console.log(err.response.data.errors)
              })
    },

    // object.assign fills in the empty object with the properties of item
    editItem (item, dbox = true) {
      this.editedItem = Object.assign({}, item)
      this.itemDialog = dbox
      this.updatingItem = true
      this.itemErrorMessage = ''
    },

    // object.assign fills in the empty object with the properties of item
    editSubscription (item, dbox = true) {
      this.editedIndex = this.SubscriptionList.indexOf(item)
      var sub = Object.assign({}, item)
      self = this
      for (var i = 0; i < sub.items.length; i++) {
        for (var j = 0; j < self.serviceList.length; j++) {
          if (sub.items[i].service_id == self.serviceList[j].id) {
            sub.items[i].service = self.serviceList[j]
            break
          }
        }
      }
      this.editedSubscription = sub
      this.dialog = dbox
      this.updating = true
      this.subscriptionErrorMessage = ''
    },

    callTableAction (item, endpoint, method) {
      let tableItem = this.editedSubscription
      this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
        .then((response) => this.saveInline())
        .catch(error => {
          console.log(error)
          this.cancelInline
        })
    },

    // deleteItem (item) {
    //   const index = this.SubscriptionList.indexOf(item)
    //   if (confirm('Are you sure you want to delete this item?'))
    //   {
    //     axios.delete('/api/admin/subscriptions/' + item.id)
    //             .then((response) => {
    //               this.SubscriptionList.splice(index, 1)
    //               this.deleteInline()
    //                       this.close()
    //                     }
    //             )
    //             .catch(error => {
    //               if (error.response.status == '403') {
    //                 this.showError('Unauthorized');
    //               } else {
    //                 this.showError(error.response.data.errors);
    //               }
    //               console.log(error)
    //               this.cancelInline
    //             })
    //   }
    // },

    close () {
      this.dialog = false
      this.updating = false
      setTimeout(() => {
        this.editedSubscription = Object.assign({}, this.defaultSubscription)
        this.editedIndex = -1
      }, 300)
    },

    cancelSubscription () {
      this.$store.state.spinning = true
      if (this.editedSubscription.id == '') {
        return
      }
      axios.delete('/api/admin/subscriptions/' + this.editedSubscription.id)
          .then((response) => {
            Object.assign(this.SubscriptionList[this.editedIndex], response.data)
            this.editedSubscription = response.data

            this.deleteInline()
            this.close()
            this.$store.state.spinning = false
          })
          .catch(error => {
            if (error.response.status == '422') {
              this.showError(error.response.data.errors)
            }
            console.log(error)
            this.cancelInline
            this.$store.state.spinning = false
          })
    },
    save () {
      if (this.editedSubscription.payment_type == 'recurring' && this.editedSubscription.start_date == '') {
        this.subscriptionErrorMessage = 'Please fill out Contract Start Date for the subscription!'
        return
      }

      if (this.editedSubscription.items.length == 0) {
        this.subscriptionErrorMessage = 'Please add services!'
        return
      }
      this.$store.state.spinning = true
      axios.post('/api/admin/subscriptions', this.editedSubscription)
              .then((response) => {
                this.SubscriptionList.unshift(response.data)
                this.saveInline()
                this.close()
                this.$store.state.spinning = false
              })
        .catch(error => {
          if (error.response.status == '422') {
            this.showError(error.response.data.errors)
          }
          console.log(error)
          this.cancelInline
          this.$store.state.spinning = false
        })
      this.editedSubscription = this.defaultEditedSubscription
    },
    itemClose () {
      this.itemDialog = false
      this.updating = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
      }, 100)
    },

    itemSave () {
      this.updatingItem = false
      if (this.editedItem.service_id == '') {
        this.itemErrorMessage = 'Please select a service first!'
        return
      }
      for (var j = 0; j < this.serviceList.length; j++) {
        if (this.editedItem.service_id == this.serviceList[j].id) {
          this.editedItem.service = this.serviceList[j]
          break
        }
      }
      for (var i = 0; i < this.editedSubscription.items.length; i++) {
        if (this.editedSubscription.items[i].service_id == this.editedItem.service_id) {
          // if item is being edited
          if (this.editedItem.quantity == 0) {
            this.editedSubscription.items.splice(i, 1)
            this.itemClose()
            this.calculateTotalPrice()
            return
          }
          if (this.updatingItem) {
            this.editedSubscription.items[i] = this.editedItem
            this.itemClose()
            this.calculateTotalPrice()
            return
          }
          // if item is being created
          this.itemErrorMessage = 'The service is already in the subscription cart, please click to edit!'
          return
        }
      }

      this.editedSubscription.items.push(this.editedItem)
      this.calculateTotalPrice()

      this.itemClose()
    },
    calculateTotalPrice () {
      this.editedSubscription.total_price = 0
      for (var i = 0; i < this.editedSubscription.items.length; i++) {
        var discount = this.editedSubscription.items[i].discount_type == 'amount' ? this.editedSubscription.items[i].discount : this.editedSubscription.items[i].service.price * this.editedSubscription.items[i].discount / 100
        this.editedSubscription.total_price += (this.editedSubscription.items[i].service.price - discount) * this.editedSubscription.items[i].quantity
      }
    },
    // toasts/snackbar messages for actions
    saveInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Subscription saved'
    },
    deleteInline () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Subscription cancelled'
    },
    showError (errorMessage) {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = errorMessage || 'Something went wrong, try again later!'
    },
    cancelInline () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    reset () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data reset to default'
    },
    openInline () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    closeInline () {
      console.log('Dialog closed')
    },
    showWarningMessage (message) {
      this.snack = true
      this.snackColor = 'warning'
      this.snackText = message
    }
  }
}
</script>

<style>
table.v-table thead tr {
  color: red !important;
}
tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, .05);
}
.cycles {
  position: relative;
  width:100%;
  /*top: 350px;*/
}
.cycles .v-select-list {
  position:relative;
}
.cycles .v-select-list .v-list {
  /*padding-top:20px;*/
  width: 300px;
  min-height: 300px;
}
.cycles .v-select-list .v-list div {
  display:inline-flex;
  width: 30px;
  margin: 5px;
  text-align: center;
}
.cycles .v-select-list .v-list div .v-list__tile {
  padding: 0;
}
.cycles .v-menu__content {
  top: 0 !important;
  left: 0 !important;
}
</style>
